// cargo details constants for international IPB
export const MAX_TOTAL_WEIGHT_LB = 44092;
export const MAX_TOTAL_WEIGHT_KG = 20000;

export const MAX_TOTAL_VOLUME_CU_FT = 2649;
export const MAX_TOTAL_VOLUME_CBM = 75;
